import { connectInfiniteHits } from 'instantsearch.js/es/connectors';

let lastRenderArgs;
let listeners = [];

const nextPageUrl = (page) => {
  const baseUrl = window.location.href.split('?')[0];
  const urlSearchParams = new URLSearchParams(window.location.search);

  urlSearchParams.set('page', page + 1);

  return baseUrl + '?' + urlSearchParams.toString();
};

const renderFn = (renderArgs, isFirstRender) => {
  const { hits, showMore, widgetParams, sendEvent, results } = renderArgs;
  const { container, paginationSentinel } = widgetParams;
  const showMoreLink = paginationSentinel.querySelector('a');

  lastRenderArgs = renderArgs;

  if (isFirstRender) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !lastRenderArgs.isLastPage) {
          showMore();
        }
      });
    });

    observer.observe(paginationSentinel);

    showMoreLink.addEventListener('click', (event) => {
      event.preventDefault();
      event.target.blur();
      showMore();
    });

    return;
  }

  container.innerHTML = '';

  hits.forEach((hit) => {
    // clear infinite hits cache and reload the window if hit template not found
    if (hit.template == undefined) {
      sessionStorage.removeItem('ais.infiniteHits');
      window.location = window.location;
    }

    let li = document.createElement('li');
    li.classList = 'bg-white rounded-md shadow overflow-hidden';
    li.innerHTML = hit.template;

    // add data attributes for analytics tracking
    li.dataset.objectId = hit.objectID;
    li.dataset.position = hit.__position;
    li.dataset.queryId = hit.__queryID;

    var url = new URL(li.querySelector('a').href);
    url.searchParams.append('objectID', hit.objectID);
    url.searchParams.append('queryID', hit.__queryID);
    li.querySelector('a').href = url;

    container.appendChild(li);
  });

  showMoreLink.setAttribute('href', nextPageUrl(results?.page + 1));

  [...container.children].forEach((child, index) => {
    let element = child.querySelector('a');

    if (listeners[index]) {
      element.removeEventListener('click', listeners[index]);
    }

    listeners[index] = () => {
      sendEvent('click', hits[index], 'Opportunity Clicked');
    };

    element.addEventListener('click', listeners[index]);
  });
};

const infiniteHits = connectInfiniteHits(renderFn);

export const opportunities = (widgetParams) => infiniteHits(widgetParams);
